import { TextLibraryEntry } from '../types';

/**
 * The text inserted into the design: the title on the first line (unless left out), then the chosen verses in their
 * original order, each separated by a blank line. Unknown verse indexes are ignored.
 */
function buildTextLibraryText(entry: TextLibraryEntry, verseIndexes: number[], includeTitle = true): string {
  const verses = [...new Set(verseIndexes)]
    .filter((index) => index >= 0 && index < entry.verses.length)
    .sort((a, b) => a - b)
    .map((index) => entry.verses[index]);
  return [...(includeTitle ? [entry.title] : []), ...verses].join('\n\n');
}

export default buildTextLibraryText;
